// import React, { useState } from "react";
// import { Link, useLocation } from "react-router-dom";
// // import { useLazyLogoutQuery } from "../../redux/api/authApi";

// const SideMenu = () => {
//   const location = useLocation();

//   const [activeMenuItem, setActiveMenuItem] = useState(location.pathname);

//   const menuItems = [
//     { name: "Profile", url: "/me/profile" },
//     { name: "Edit Profile", url: "/me/update_profile" },
//     { name: "Change Password", url: "/me/update_password" },
//     { name: "Orders", url: "/me/orders" },
//   ];

//   // const [logout, { isSuccess }] = useLazyLogoutQuery();

//   const handleMenuItemClick = (menuItemUrl) => {
//     setActiveMenuItem(menuItemUrl);
//   };

//   // const logoutHandler = () => {
//   //   logout();
//   // };

//   return (
//     <aside className="bg-[#f5f5dc] md:border-r border-stone-300 w-full md:w-64  ">
//       <h2 className="text-xl font-playfair text-amber-700 mb-2 px-2">
//         My Account
//       </h2>
//       <nav className="space-y-0">
//         {menuItems.map((item, index) => (
//           <Link
//             key={index}
//             to={item.url}
//             onClick={() => handleMenuItemClick(item.url)}
//             className={`block text-sm font-sourcesans rounded-md w-40 py-1 px-2 transition 
//               ${
//                 activeMenuItem === item.url
//                   ? "border border-amber-700 text-amber-700 font-medium"
//                   : "text-stone-600 hover:text-amber-700"
//               }`}
//           >
//             {item.name}
//           </Link>
//         ))}
//         {/* <Link
//           to="/"
//           onClick={logoutHandler}
//           className={
//             "block text-sm font-sourcesans rounded-md w-40 py-1 px-2 transition border-amber-700 text-amber-700 font-medium"
//           }
//           reloadDocument
//         >
//           Sign Out
//         </Link> */}
//       </nav>
//     </aside>
//   );
// };

// export default SideMenu;

import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const SideMenu = ( { menuItems } ) => {
  const location = useLocation();
  const [activeMenuItem, setActiveMenuItem] = useState(location.pathname);



  const handleMenuItemClick = (menuItemUrl) => {
    setActiveMenuItem(menuItemUrl);
  };




  return (
    <aside className="bg-[#f5f3ea] md:border-r border-[#8a4b32]/40 w-full md:w-64 p-4 rounded-md shadow-sm">
      <h2 className="text-xl font-playfair text-[#BC3F4A] mb-4">
        My Account
      </h2>
      <nav className="space-y-2">
        {menuItems?.map((item, index) => (
          <Link
            key={index}
            to={item.url}
            onClick={() => handleMenuItemClick(item.url)}
            className={`block text-sm font-sourcesans rounded-md w-full py-2 px-3 transition-colors
              ${
                activeMenuItem === item.url
                  ? "border border-[#BC3F4A] text-[#BC3F4A] font-medium bg-white/30 backdrop-blur-sm"
                  : "text-[#1c1917] hover:text-[#BC3F4A] hover:bg-white/20 backdrop-blur-sm"
              }`}
          >
            {item.name}
          </Link>
        ))}
      </nav>
    </aside>
  );
};

export default SideMenu;

